// extracted by mini-css-extract-plugin
export default {"menuContainer":"menu_menuContainer__rocLq"};